import { ERROR_ACTION, GET_DUPLICATES_BY_IDS, GET_APPLICATION_LIST, SET_ROLLNO_QUALIFIED_CANDIDATE,SET_PENDING_ACTIVITIES, SET_CURRENT_ACTIVITIES, SET_ALL_ACTIVITIES, SET_RECOMMENDATION_REPORTS } from "../../common/constants/ActionTypes";

const initialState = {
  applicationList: [],
};

export default function administrationReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
     case GET_DUPLICATES_BY_IDS:{
      return{
        ...state,
        getduplicatelistingbyids:action.payload
      }
     };
     case GET_APPLICATION_LIST:
      return {
        ...state,
        applicationList: action.payload,
      };
       case SET_ROLLNO_QUALIFIED_CANDIDATE:
        return{
          ...state,
          rollNoQualifiedCandidate:action.payload,
        }
       case SET_PENDING_ACTIVITIES:{
        return{
          ...state,
          listPendingActivities:action.payload
        }
       }
       case SET_CURRENT_ACTIVITIES:{
        return{
          ...state,
          listCurrentActivities:action.payload
        }
       }
       case SET_ALL_ACTIVITIES:{
        return{
          ...state,
          listallActivities:action.payload
        }
       }
       case SET_RECOMMENDATION_REPORTS:{
        return{
          ...state,
          listRecommendationReports:action.payload
        }
       }
    default:
      return state;
  }
}
